import { ReceiptFooterSectionProps } from "./types";
import { VStack } from "@gluestack-ui/themed";

import { Text } from "@repo/core/components/core/Text";

import WayupLogoLogista from "@repo/core/assets/images/wayup-logo-logista.svg";

export const ReceiptFooterSection = ({
  transactionId
}: ReceiptFooterSectionProps) => {
  return (
    <VStack p="$6" bg="$backgroundLight100" gap={12}>
      <WayupLogoLogista />
      <Text fontWeight={600} fontSize="$xs">
        WayUp Brasil Administradora de Meios de Pagamento Ltda - CNPJ
        19.951.708/0001-56
      </Text>
      <VStack>
        <Text fontSize="$xs">ID da transação</Text>
        <Text fontWeight={500} fontSize="$xs">
          {transactionId}
        </Text>
      </VStack>
    </VStack>
  );
};
